// extracted by mini-css-extract-plugin
module.exports = {"crossButton":"Contect-account_crossButton__uiFHx","closeButton":"Contect-account_closeButton__U_RHw","searchButton":"Contect-account_searchButton__2OklD"};